import type { ProjectSolarPotential } from '@/api/queries/project/useGetProjectSolarPotential';
import type { SolarRecommendedApplianceFieldsFragment } from '@/gql/graphql';
import type { SolarLatLng } from '@payaca/components/solarRoofView/SolarRoofView';

export const MANUAL_DESIGN_SOURCE_ID = 'manual';

/**
 * The designer's source for a hand-drawn roof: a plain map at the site point
 * with no satellite panels, configurations or imagery. Products come from the
 * saved design, which reads the account catalogue without an analysis.
 */
export const manualDesignSource = (
  centre: SolarLatLng,
  draft: {
    recommendedPanelAppliances?:
      | SolarRecommendedApplianceFieldsFragment[]
      | null;
    recommendedBatteryAppliances?:
      | SolarRecommendedApplianceFieldsFragment[]
      | null;
  }
): ProjectSolarPotential => ({
  sourceAnalysisId: MANUAL_DESIGN_SOURCE_ID,
  sourceAnalysisVersion: MANUAL_DESIGN_SOURCE_ID,
  available: true,
  centre,
  panels: [],
  roofSegments: [],
  configurations: [],
  defaultConfigurationIndex: 0,
  geometry: null,
  recommendedPanelAppliances: draft.recommendedPanelAppliances ?? [],
  recommendedInverterAppliances: [],
  recommendedBatteryAppliances: draft.recommendedBatteryAppliances ?? [],
});
